import React from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";

/** Page title block: optional back button, title, description and right-side actions. */
const PageHeader = ({ title, description, onBack, actions, className = "" }) => (
  <div className={`mb-6 flex flex-wrap items-start justify-between gap-3 ${className}`}>
    <div className="flex items-start gap-3">
      {onBack && (
        <Button variant="outline" size="icon" onClick={onBack} aria-label="Go back" className="mt-0.5 h-9 w-9 shrink-0">
          <ArrowLeft />
        </Button>
      )}
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
